import { Workbox } from "workbox-window";

export default function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    // Construct the service worker URL dynamically with version query param to bust cache
    const swfilePath =
      window._siteProps_?.props?.staticimgbaseurl?.replace("/default", "") +
      "/sw.js" +
      "?v=" +
      window.version; // Make sure window.version increments on each deploy
    // const swfilePath =
    //   "http://localhost:8080/jfl-discovery-ui/public/dist/sw.js";
    const wb = new Workbox(swfilePath);

    // Prompt user to refresh when a new service worker is waiting to activate
    const showSkipWaitingModal = () => {
      if (confirm("New sw app update is available! Click OK to refresh.")) {
        // Listen for controlling event — fired when new SW takes control
        wb.addEventListener("controlling", () => {
          console.log("User accepted update prompt, reloading now...");
          window.location.reload();
        });

        // Tell waiting SW to skip waiting and activate immediately
        wb.messageSkipWaiting();
      } else {
        console.log("User dismissed update prompt.");
      }
    };

    // Fired when service worker is activated
    wb.addEventListener("activated", (event) => {
      if (!event.isUpdate) {
        console.info("Service worker activated for the first time!");
      } else {
        console.info("Service worker updated and activated!");
      }
      // Claim clients immediately so new SW controls all pages
      wb.messageSW({ type: "CLIENTS_CLAIM" });
    });

    // Fired when new SW installed but waiting to activate (update available)
    wb.addEventListener("waiting", showSkipWaitingModal);

    // Fired when SW installed (first time or update)
    wb.addEventListener("installed", (event) => {
      if (!event.isUpdate) {
        console.info("Service worker installed for the first time");
      } else {
        console.info("Service worker installed (update)");
      }
    });

    // Register the service worker with specified scope
    navigator.serviceWorker
      .register(swfilePath, {
        scope: "/jfl-discovery-ui",
      })
      .then(() => {
        console.log("Service worker registered with scope '/jfl-discovery-ui'");
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  } else {
    console.log(
      "Service Worker is not supported in your browser, please update your browser for a smooth experience."
    );
  }

  // Uncomment if you want to handle PWA install prompt later
  /*
  var defferedPrompt;
  window.addEventListener('beforeinstallprompt', (event) => {
    console.log("beforeinstallprompt");
    event.preventDefault();
    defferedPrompt = event;
    showInstallPromotion();
  });
  */
}
